import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModelService {
  getModel() {
    return sessionStorage.getItem('spareVehicleDetails');
  }
}
